import { render, staticRenderFns } from "./SampleTable.vue?vue&type=template&id=1cf911cb&scoped=true&"
import script from "./SampleTable.vue?vue&type=script&lang=js&"
export * from "./SampleTable.vue?vue&type=script&lang=js&"
import style0 from "./SampleTable.vue?vue&type=style&index=0&id=1cf911cb&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cf911cb",
  null
  
)

export default component.exports